import { render, staticRenderFns } from "./user-autocomplete.vue?vue&type=template&id=9753b60e&"
import script from "./user-autocomplete.vue?vue&type=script&lang=js&"
export * from "./user-autocomplete.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports